var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-version-footer"},[_c('div',{class:['cmp-error-message']},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(this.getItem('compareVersionsError')))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }